<template>
  <div>
    <GmapMarker
      v-if="from.location"
      :position="position(from)"
      :icon="icon('from')"
      :animation="getAnimation()" />
    <GmapMarker
      v-if="to.location"
      :position="position(to)"
      :icon="icon('to')"
      :animation="getAnimation()" />
    <GmapMarker
      v-if="via.location"
      :position="position(via)"
      :icon="icon('via')"
      :animation="getAnimation()" />
  </div>
</template>

<script>
import { gmapApi } from 'vue2-google-maps'
import { mapGetters } from 'vuex'

export default {
  computed: {
    google: gmapApi,
    ...mapGetters({
      from: 'map/getSearchFrom',
      to: 'map/getSearchTo',
      via: 'map/getSearchVia'
    })
  },
  methods: {
    position: function (place) {
      return {
        lat: place.location.latitude,
        lng: place.location.longitude
      }
    },
    icon: function (type) {
      if (this.google) {
        switch (type) {
          case 'from':
            return {
              url: require('@/assets/images/mapmarker/searchFromMarker.png'),
              scaledSize: new this.google.maps.Size(38, 38)
            }
          case 'to':
            return {
              url: require('@/assets/images/mapmarker/searchToMarker.png'),
              scaledSize: new this.google.maps.Size(38, 38)
            }
          case 'via':
            return {
              url: require('@/assets/images/mapmarker/searchViaMarker.png'),
              scaledSize: new this.google.maps.Size(38, 38)
            }
        }
      }
    },
    getAnimation: function () {
      if (this.google) {
        return this.google.maps.Animation.DROP
      }
    }
  }
}
</script>
